import axios from "../axios";

export default {
  getExamList() {// 获取考试列表
    return axios.get("api/exam/getExamList");
  },
  addExamInfo(data) {  // 添加考试报名信息
    return axios.post("api/exam/addExamInfo", data)
  },
  getUserExamList(data) {  // 获取用户报名的信息
    return axios.post("api/exam/getUserExamList", data)
  },
  getUserInfo(data) {  // 获取用户信息
    return axios.post("api/exam/getUserInfo", data)
  },
  getExamGroupList(data) {  // 获取学习组信息
    return axios.post("api/exam/getExamGroupList", data)
  },
  getExamDataList(data) {  // 获取学习资料
    return axios.post("api/exam/getExamDataList", data)
  },
  getUserDiscount(data) {  // 获取用户购买的课程进行报名优惠
    return axios.post("api/exam/getUserDiscount", data)
  },
  getUserExamInfoById(data) {  // 获取用户报名的详情
    return axios.post("api/exam/getUserExamInfoById", data)
  },
  payExamOrder(data) {  // 订单支付
    return axios.post("api/exam/payExamOrder", data)
  },
  getPatType(data) {  // 检测是否支付完成
    return axios.post("api/exam/examOrderStater", data)
  }

};